import { combineReducers } from 'redux';
import favorites from "./favorites";
import moviesNow from "./moviesNow";
import moviesSearch from "./moviesSearch";
import loading from "./loading";
import error from "./error";
import query from "./query";

export default combineReducers({ favorites, moviesNow, moviesSearch, loading, error, query })